/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAcos } from '../../factoriesAny.js';
export var acosDependencies = {
  ComplexDependencies,
  typedDependencies,
  createAcos
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesAcos.generated.js
// module id = null
// module chunks = 